import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { toast } from '@/components/ui/sonner';
import { startTournament } from '@/data/start-tournament';
import type { Participant, Tournament } from '@/data/types';

interface Props {
  tournament: Tournament;
  participants: Participant[];
}

export function StartTournamentButton({ tournament, participants }: Props) {
  const [submitting, setSubmitting] = useState(false);

  async function handleStart() {
    if (participants.length < 2) {
      toast.error('Нужно минимум 2 участника');
      return;
    }
    if (tournament.status === 'DRAFT') {
      if (!confirm('Жеребьёвка не зафиксирована — будет использован порядок по умолчанию. Продолжить?')) {
        return;
      }
    }
    if (!confirm('Сгенерировать сетку и стартовать турнир? Состав уже не изменить.')) return;

    setSubmitting(true);
    try {
      await startTournament(tournament, participants);
      toast.success('Сетка сгенерирована, турнир стартовал');
    } catch (err) {
      toast.error('Не получилось', { description: String((err as Error).message) });
    } finally {
      setSubmitting(false);
    }
  }

  if (tournament.status !== 'DRAFT' && tournament.status !== 'READY') {
    return null;
  }

  return (
    <button
      className="btn btn-primary"
      onClick={handleStart}
      disabled={submitting || participants.length < 2}
    >
      {submitting ? (
        <>
          <span className="spinner" /> Генерируем...
        </>
      ) : (
        <>
          <Sparkles size={14} /> Сгенерировать сетку и стартовать
        </>
      )}
    </button>
  );
}
